import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Pagination } from "antd";
import Spinner from "../common/Spinner";
import TrademarkItem from "./TrademarkItem";

import "./index.css";

const Trademark = ({ search, loading, language, labels }) => {
  const [current, setCurrent] = useState(1);
  const [marks, setMarks] = useState([]);
  const { resultLabel } = labels;
  let lang = "";
  if (language == 0) lang = "Kp";
  if (language == 1) lang = "En";
  if (language == 2) lang = "Cn";
  if (language == 3) lang = "Ru";

  useEffect(() => {
    axios
      .get(`/api/trademark?search=${search}&language=${language}`)
      .then((res) => {
        setMarks(res.data);
        // console.log(res.data);
      })
      .catch();
  }, [search]);

  useEffect(() => {
    axios
      .post(`/api/log`, {
        title: "상표",
        lang: lang,
        type: "기사",
      })
      .then((res) => {
        // setMarks(res.data);
        // console.log(res.data);
      })
      .catch();
  }, []);

  let markItems;

  if (marks === null || marks.length === 0 || loading) {
    markItems = <></>;
  } else {
    if (marks.length > 0) {
      markItems = marks
        .slice((current - 1) * 4, current * 4)
        .map((mark) => <TrademarkItem key={mark._id} mark={mark} />);
    } else {
      markItems = <></>;
    }
  }

  return (
    <div className="trademark">
      <img className="w-100" src="./assets/trademark_banner.jpg" alt="" />
      <div className="container pt-5">
        <div className="d-flex flex-column">
          {/* <p className="mb-5">
            {resultLabel[language]}:&nbsp;
            {marks ? marks.length : "0"}
          </p> */}
          <div className="d-flex flex-wrap justify-content-around trademark-item-space">
            {markItems}
          </div>
        </div>
        <div className="d-flex justify-content-center py-5">
          <Pagination
            defaultCurrent={1}
            total={marks.length}
            pageSize={4}
            showSizeChanger={false}
            onChange={(page) => {
              setCurrent(page);
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.profile.loading,
  search: state.profile.search,
  language: state.profile.language,
  labels: state.labels,
});

export default connect(mapStateToProps, {})(Trademark);
